/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PrivateRoute_viewer = {
    readonly user: {
        readonly roles: ReadonlyArray<{
            readonly name: string;
        }>;
    } | null;
    readonly " $refType": "PrivateRoute_viewer";
};
export type PrivateRoute_viewer$data = PrivateRoute_viewer;
export type PrivateRoute_viewer$key = {
    readonly " $data"?: PrivateRoute_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PrivateRoute_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PrivateRoute_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "roles",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'f6909b3aa39047d83b85086d2adf5066';
export default node;
